import React from 'react';
import styled from 'styled-components';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { BREAKPOINT_MD, CONTAINER_MAX_WIDTH } from '../../theme/ota';
interface HotelCriteriaSkeletonProps {
  searchEngine_orientation?: 'VERTICAL' | 'HORIZONTAL';
  enablePromoCode?: boolean;
  enableClientList?: boolean;
  isLongStay?: boolean;
}
const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: ${CONTAINER_MAX_WIDTH};
  margin: 0 auto;
`;
const ContainerGrid = styled.div<{
  verticalOrientation?: boolean;
}>`
  display: flex;
  gap: 15px;
  flex-wrap: ${({
  verticalOrientation
}) => verticalOrientation ? 'wrap' : ''};
  width: 100%;
  margin-bottom: 30px;

  @media (max-width: calc(${BREAKPOINT_MD})) {
    flex-wrap: wrap;
  }
`;
const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;

  @media (min-width: calc(${BREAKPOINT_MD})) {
    &.destination-field {
      min-width: ${({
  verticalOrientation
}: {
  verticalOrientation?: boolean;
}) => verticalOrientation ? '100%' : '200px'};
    }
    &.date-field {
      min-width: ${({
  verticalOrientation
}: {
  verticalOrientation?: boolean;
}) => verticalOrientation ? '100%' : '250px'};
      max-width: ${({
  verticalOrientation
}: {
  verticalOrientation?: boolean;
}) => verticalOrientation ? '100%' : '297px'};
    }
    &.occupancy-field {
      max-width: ${({
  verticalOrientation
}: {
  verticalOrientation?: boolean;
}) => verticalOrientation ? '100%' : '210px'};
    }
    &.client-field {
      max-width: ${({
  verticalOrientation
}: {
  verticalOrientation?: boolean;
}) => verticalOrientation ? '100%' : '190px'};
    }
    &.promocode-field {
      max-width: ${({
  verticalOrientation
}: {
  verticalOrientation?: boolean;
}) => verticalOrientation ? '100%' : '174px'};
    }
    &.button-field {
      width: ${({
  verticalOrientation
}: {
  verticalOrientation?: boolean;
}) => verticalOrientation ? '100%' : '100px'};
      align-self: flex-end;
    }
  }
`;
const HotelCriteriaSkeleton: React.FC<HotelCriteriaSkeletonProps> = ({
  searchEngine_orientation = 'HORIZONTAL',
  enablePromoCode = false,
  enableClientList = false,
  isLongStay = false
}) => {
  const verticalOrientation = searchEngine_orientation === 'VERTICAL';
  return <Container>
      <div style={{
      width: '100%'
    }}>
        <ContainerGrid verticalOrientation={verticalOrientation}>
          <Field className="destination-field" verticalOrientation={verticalOrientation}>
            <Skeleton className="title-skeleton" width="120px" height="16px" />
            <Skeleton className="input-skeleton" width="100%" height="42px" />
          </Field>

          <Field className="date-field" verticalOrientation={verticalOrientation}>
            <Skeleton className="title-skeleton" width="140px" height="16px" />
            <Skeleton className="input-skeleton" width="100%" height="42px" />
          </Field>

          {!isLongStay && <Field className="occupancy-field" verticalOrientation={verticalOrientation}>
              <Skeleton className="title-skeleton" width="80px" height="16px" />
              <Skeleton className="input-skeleton" width="100%" height="42px" />
            </Field>}

          {enableClientList && <Field className="client-field" verticalOrientation={verticalOrientation}>
              <Skeleton className="title-skeleton" width="60px" height="16px" />
              <Skeleton className="input-skeleton" width="100%" height="42px" />
            </Field>}

          {enablePromoCode && <Field className="promocode-field" verticalOrientation={verticalOrientation}>
              <Skeleton className="title-skeleton" width="110px" height="16px" />
              <Skeleton className="input-skeleton" width="100%" height="42px" />
            </Field>}

          <Field className="button-field" verticalOrientation={verticalOrientation}>
            <Skeleton className="button-skeleton" width="100%" height="42px" />
          </Field>
        </ContainerGrid>
      </div>
    </Container>;
};
export default HotelCriteriaSkeleton;